export default __webpack_public_path__ + "static/media/733.97917d78.png";